import React, { useEffect, useState } from 'react'
import './homepage.styles.scss'

import { Routes, Route, Navigate, useNavigate } from 'react-router-dom'

import Footer from '@/components/footer/footer.component'
import { Sources } from '@/forms/formTypes'
import Header2025 from '../../components/header-2025/header-2025.component'
import MyEvalsList from '../../components/HOME/home-content/my-evals-list.component'
import { useSelector } from 'react-redux'
import Loader from '../../components/SHARED/loader/loader.comp'


const HomePage = () => {

	const userProfile = useSelector(state => state.userData.userProfile);
	const [noId, setNoId] = useState(true);
	const navigate = useNavigate();

	useEffect(() => {
		if (!userProfile) return;
		const savedPath = localStorage.getItem('evalPath');
		if (savedPath) {
			navigate(`/eval/${savedPath}`); 
		} else {
			setNoId(false);
		}
	}, [userProfile])

		// useEffect(() => {
		// 	const header = document.getElementsByClassName('header-2025')[0]
		// 	console.log('source', platform)
		// 	if (platform && platform !== 'eln' && platform !== 'ipa') {
		// 		const sourceCat = Sources[platform].cat;
		// 		header.classList.add(sourceCat)
		// 		setPlatform(sourceCat)
		// 	} else if (platform) {
		// 		header.classList.add(platform)
		// 	} else {
		// 		header.classList.remove('eln')
		// 		header.classList.remove('ipa')
		// 	}


		// }, [platform])

	return (
		<div className='homepage'>
			<Header2025 />
			{
				(noId)
					?
					<div className='homepage_loader'>
						<Loader />
					</div>
					:
					<div className='homepage_content'>
						<Routes>
							<Route path='' element={
								<MyEvalsList />
							}></Route>
							{/* <Route path='ipa' element={
							<MyEvalsList setPlatform={setPlatform} type={'ipa'} />
						}></Route> */}
						</Routes>
					</div>
			}
			<Footer />
		</div>
	)
}

export default HomePage